import { useLocation } from 'react-router-dom';
import { FaBars } from 'react-icons/fa';
import './Header.css';

const PAGE_TITLES = {
  '/': 'Dashboard',
  '/inventory': 'Inventory Management',
  '/accessories': 'Accessories & Templates',
  '/orders': 'Order Management',
  '/customers': 'Customer Management',
  '/tailors': 'Tailor Management',
  '/assignments': 'My Assignments',
  '/reports': 'Reports & Analytics',
  '/users': 'User Management',
};

export default function Header({ onSidebarToggle = () => { } }) {
  const location = useLocation();
  const title = PAGE_TITLES[location.pathname] || 'RCITMS';
  const today = new Date().toLocaleDateString('en-IN', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' });

  return (
    <header className="app-header">
      <div className="header-left">
        <button className="header-toggle" onClick={onSidebarToggle} aria-label="Toggle menu">
          <FaBars size={20} />
        </button>
        <h1 className="header-title">{title}</h1>
      </div>
      <div className="header-right">
        <div className="header-date">{today}</div>
        <div className="header-status">
          <span className="status-dot"></span>
          <span className="text-sm text-muted">Live</span>
        </div>
      </div>
    </header>
  );
}
